import { createFileRoute } from '@tanstack/react-router'
import { SobrePageViewModel } from '@/components/about/sobre-page/sobre-page.view-model'
import { buildPageMeta } from '@/lib/seo/build-page-meta'

export const Route = createFileRoute('/_editorial/sobre')({
  head: () =>
    buildPageMeta({
      title: 'Sobre o Ateliê — Flora Ateliê',
      description:
        'Conheça o atelier Flora Ateliê: curadoria diária de flores frescas e buquês montados à mão, com entrega em toda a cidade.',
      path: '/sobre',
    }),
  component: SobrePageViewModel,
})
